import { isProvisionalIdentifier } from '../util';

class Document {
  constructor(data) {
    data = data || {};

    this.id = data.id || null;
    this.name = data.name || null;
    this.user_id = data.user_id || null;
    this.creation_date = data.creation_date || null;
    this.events_id = data.events_id || null;
    this.venues_id = data.venues_id || null;
    this.folders_id = data.folders_id || null;
    this.description = data.description || null;
    this.title = data.title || null;
    this.size = data.size || null;
    this.venue_id = data.venue_id || null;
    this.highlight = data.highlight || null;
    this.caption = data.caption || null;
    this.show_user_id = data.show_user_id || null;
    this.profile_photo = data.profile_photo || null;
    this.request_id = data.request_id || null;
    this.type = data.type || null;
    this.mime_type = data.mime_type || null;
    this.contact_info_id = data.contact_info_id || null;
    this.documents_pkey = data.documents_pkey || null;
    this.staffing_users_id = data.staffing_users_id || null;
    this.programs_id = data.programs_id || null;
    this.venues_venues_activities_id = data.venues_venues_activities_id || null;
    this.product_brands_id = data.product_brands_id || null;
    this.product_labels_id = data.product_labels_id || null;
    this.created_at = data.created_at || null;
    this.updated_at = data.updated_at || null;
    this.file_modified_timestamp = data.file_modified_timestamp || null;

    this.fileDataURL = data.fileDataURL || null;
  }

  get isUploaded() {
    return !isProvisionalIdentifier(this.id);
  }

  get hasFileForUpload() {
    return !!this.fileDataURL;
  }

}

export default Document;
